import * as Yup from 'yup'

const bankTransactionLinkOrderSchema = Yup.object().shape({
  customer_order_number: Yup.number().required('Tolong masukan Order Number')
})

export default bankTransactionLinkOrderSchema